import Close from "@mui/icons-material/Close";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import CachedIcon from "@mui/icons-material/Cached";
import {
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { makeStyles } from "@mui/styles";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  GridToolbarContainer,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import {
  createAdminCarrier,
  deleteAdminCarrier,
  getAdminCarrier,
  updateAdminCarrier,
} from "../../redux/actions/adminPortal_carrierAction";
import { StyledDataGrid } from "../../pages/CustomDataGrid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { toast } from "react-toastify";
import { api } from "../../mockData";
import axios from "axios";
import PageTitle from "../common/PageTitle";

const drawerWidth = 240;

const useStyles = makeStyles({
  borderedGreen: {
    borderLeft: "3px solid green", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  borderedRed: {
    borderLeft: "3px solid red", // Add your border styling here
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  spacedRow: {
    // Adjust spacing here, e.g., margin, padding, etc.
    marginBottom: "10px",
  },
  tooltip: {
    backgroundColor: "#0E397F", // Change default background color
    color: "white",
    "&:hover": {
      backgroundColor: "#0E397F", // Change background color on hover
    },
  },
});

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  );
}

function AdminCarrier({ colorThem }) {
  const theme = useTheme();
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [response, setResponse] = useState("");
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [regType, setRegType] = useState("");
  const [routeType, setRouteType] = useState("");
  const [username, setUsername] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [tollFreePriority, setTollFreePriority] = useState("");
  const [localPriority, setLocalPriority] = useState("");
  const [status, setStatus] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [carrierId, setCarrierId] = useState("");

  const handleOpen = () => setOpen(true);

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleAlertClose = () => {
    setCarrierId("");
    setName("");
    setAlertMessage(false);
  };

  const handleClose = () => {
    setOpen(false);
    setName("");
    setIpAddress("");
    setCountryCode("");
    setType("");
    setRegType("");
    setUsername("");
    setPassword("");
    setStatus("");
    setRouteType("");
    setTollFreePriority("");
    setLocalPriority("");
  };

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
    setName("");
    setIpAddress("");
    setCountryCode("");
    setType("");
    setRegType("");
    setUsername("");
    setPassword("");
    setStatus("");
    setRouteType("");
    setTollFreePriority("");
    setLocalPriority("");
  }, []);

  const handleButtonClick = useCallback((row) => {
    setOpenModal(true);
    setName(row.name);
    setIpAddress(row.sip_server);
    setTollFreePriority(row.priority);
    setLocalPriority(row.local_priority);
    setCountryCode(row.country_code);
    setType(row.type);
    setRegType(row.reg_type);
    setUsername(row.username);
    setPassword(row.password);
    setStatus(row.status === true ? "t" : "f");
    // Capitalize the first letter and keep the rest as is
    setRouteType(
      row.route_type.charAt(0).toUpperCase() + row.route_type.slice(1),
    );
  }, []); // Memoize event handler

  const handleSubmit = (e) => {
    e.preventDefault();
    let data = JSON.stringify({
      name: name,
      sip_server: ipAddress,
      tf_priority: tollFreePriority,
      local_priority: localPriority,
      reg_type: regType,
      type: type,
      username: username,
      password: password,
      is_active: status,
    });

    dispatch(createAdminCarrier(data, setOpen, setResponse, handleClose));
  };

  const handleUpdate = useCallback(
    (e) => {
      e.preventDefault();
      let data = JSON.stringify({
        // id:id,
        name: name,
        sip_server: ipAddress,
        tf_priority: tollFreePriority,
        local_priority: localPriority,
        type: type,
        reg_type: regType,
        username: username,
        password: password,
        is_active: status,
        // country_code: countryCode,
      });
      dispatch(
        updateAdminCarrier(data, setOpenModal, setResponse, handleCloseModal),
      );
    },
    [
      name,
      ipAddress,
      tollFreePriority,
      localPriority,
      type,
      regType,
      routeType,
      username,
      status,
      password,
      setOpenModal,
      setResponse,
      handleCloseModal,
    ],
  );

  const handleMessage = useCallback(
    (data) => {
      setName(data?.name);
      setCarrierId(data?.carrierId);
      setAlertMessage(true);
    },
    [setName],
  ); // Memoize event handler

  const handleRefresh = useCallback(async () => {
    const token = JSON.parse(localStorage.getItem("admin"));
    try {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${api.dev}/api/carrierreload`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token} `,
        },
      };
      await axios
        .request(config)
        .then((response) => {
          setResponse(response?.data);
          toast.success(response?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2500,
          });
        });
    } catch (error) {
      toast.error(error?.response?.data?.msg, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
    }
  }, [dispatch]);

  const handleDelete = useCallback(
    (id) => {
      dispatch(
        deleteAdminCarrier({ name: name }, setResponse, setCarrierId, setName),
      );
      setAlertMessage(false);
    },
    [name, dispatch, setResponse, setCarrierId, setName],
  ); // Memoize event handler

  useEffect(() => {
    dispatch(getAdminCarrier());
  }, [response]);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.only("xs")); // < 600px
  const isSm = useMediaQuery(theme.breakpoints.only("sm")); // 600px - 900px
  const isMd = useMediaQuery(theme.breakpoints.only("md")); // 900px - 1200px
  const isSmallScreen = useMediaQuery(theme.breakpoints.between("sm"));

  const columns = [
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      headerAlign: "start",
      align: "start",
      width: isXs ? 80 : 90,
      minWidth: 80,
      maxWidth: 90,
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Action
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            <IconButton onClick={() => handleButtonClick(params.row)}>
              <Edit
                index={params.row.id}
                style={{
                  cursor: "pointer",
                  color: "#42765f",
                  fontSize: isMobile ? "14px" : "16px",
                }}
              />
            </IconButton>
            <Tooltip title="delete">
              <IconButton onClick={() => handleMessage(params?.row)}>
                <Delete
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontSize: isMobile ? "14px" : "16px",
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: isXs ? 80 : 100,
      minWidth: 80,
      maxWidth: 100,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Name
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              // textTransform: "capitalize",
              fontSize: "calc(0.6rem + 0.2vw)",
            }}
          >
            {params.row.name}
          </span>
        );
      },
    },

    {
      field: "username",
      headerName: "User Name",
      width: isXs ? 90 : 120,
      minWidth: 90,
      maxWidth: 120,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          User name
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <span
            style={{
              textTransform: "capitalize",
              fontSize: "calc(0.6rem + 0.2vw)",
            }}
          >
            {params.row.username}
          </span>
        );
      },
    },
    // {
    //   field: "password",
    //   headerName: "Password",
    //   headerClassName: "custom-header",
    //   headerAlign: "center",
    //   width: 150,
    //   align: "center",
    // },
    {
      field: "priority",
      headerName: "Toll Free Priority",
      headerClassName: "custom-header",
      headerAlign: "center",
      width: 100,
      align: "center",
    },

    {
      field: "local_priority",
      headerName: "Local Priority",
      headerClassName: "custom-header",
      headerAlign: "center",
      width: 100,
      align: "center",
    },
    {
      field: "reg_type",
      headerName: "Register Type",
      width: isXs ? 100 : 120,
      minWidth: 100,
      maxWidth: 120,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Register Type
        </Typography>
      ),
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "type",
      headerName: "Type",
      width: isXs ? 60 : 120,
      minWidth: 60,
      maxWidth: 120,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Type
        </Typography>
      ),
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
        >
          {params.value}
        </Typography>
      ),
    },

    // {
    //   field: "route_type",
    //   headerName: "Route Type",
    //   width: isXs ? 60 : 100,
    //   minWidth: 60,
    //   maxWidth: 100,
    //   headerClassName: "custom-header",
    //   headerAlign: "left",
    //   align: "left",
    //   renderHeader: () => (
    //     <Typography
    //       variant="body2"
    //       sx={{ fontSize: "calc(0.6rem + 0.2vw)", fontWeight: "bold",color:"white !important"}}
    //     >
    //       Route Type
    //     </Typography>
    //   ),
    //   renderCell: (params) => (
    //     <Typography
    //       variant="body2"
    //       sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
    //     >
    //       {params.value}
    //     </Typography>
    //   ),
    // },

    {
      field: "sip_server",
      headerName: "SIP Server",
      width: isXs ? 140 : 180,
      minWidth: 140,
      maxWidth: 180,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          SIP Server
        </Typography>
      ),
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontSize: "calc(0.6rem + 0.2vw)" }} // Match header size or set your own
        >
          {params.value}
        </Typography>
      ),
    },

    {
      field: "status",
      headerName: "Status",
      width: isXs ? 80 : 100,
      minWidth: 80,
      maxWidth: 100,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
          }}
        >
          Status
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div className="d-flex justify-content-between align-items-center">
            {params.row.status === true ? (
              <>
                <div
                  style={{
                    color: "green",
                    //  background: "green",
                    padding: isMobile ? "5px" : "7px",
                    borderRadius: "5px",
                    //  fontSize: "12px",
                    textTransform: "capitalize",
                    fontSize: "calc(0.6rem + 0.2vw)",
                  }}
                >
                  Active
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    color: "red",
                    // background: "red",
                    padding: isMobile ? "5px" : "7px",
                    //  borderRadius: "5px",
                    // fontSize: "12px",
                    textTransform: "capitalize",
                    fontSize: "calc(0.6rem + 0.2vw)",
                  }}
                >
                  Deactive
                </div>
              </>
            )}
          </div>
        );
      },
    },
    {
      field: "reg_status",
      headerName: "Reg. Status",
      minWidth: 110,
      flex: 1,
      headerClassName: "custom-header",
      headerAlign: "left",
      align: "left",
      renderHeader: () => (
        <Typography
          variant="body2"
          sx={{
            fontSize: "calc(0.6rem + 0.2vw)",
            fontWeight: "bold",
            color: "white !important",
            whiteSpace: "nowrap",
          }}
        >
          Reg. Status
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <div
            className="d-flex justify-content-between align-items-center"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {params.row.reg_status}
          </div>
        );
      },
    },
  ];

  const rows = useMemo(() => {
    const calculatedRows = [];
    state?.getAdminCarrier?.getCarrier &&
      state?.getAdminCarrier?.getCarrier?.forEach((item, index) => {
        calculatedRows.push({
          id: index + 1,
          sip_server: item?.sip_server,
          name: item?.name,
          priority: item?.tf_priority,
          username: item?.username,
          status: item?.is_active,
          password: item?.password,
          type: item?.type,
          reg_type: item?.reg_type,
          route_type: item?.route_type,
          reg_status: item?.status,
          local_priority: item?.local_priority,
        });
      });
    return calculatedRows;
  }, [state?.getAdminCarrier?.getCarrier]);

  return (
    <>
      <div className={`App ${colorThem} `}>
                 <div className="contant_box">
                   <Box
                     className="right_sidebox mobile_top_pddng"
                     component="main"
                     sx={{
                       flexGrow: 1,
                       p: 3,
                       width: { sm: `calc(100% - ${drawerWidth}px)` },
                     }}
                   >
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="">
                    {/* <!----> */}
                    <div className="tab-content" id="pills-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        {/* <!--role-contet--> */}
                        <div className="">
                          <div
                            className="cntnt_title"
                            style={{
                              display: "flex",
                              flex: "wrap",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: {
                                  xs: "flex-start",
                                  md: "space-between",
                                },
                                alignItems: "center",
                                gap: { xs: 2, md: 0 },
                                textAlign: { xs: "left", md: "left" },
                                width: "100%",
                              }}
                            >
                              {/* Title */}
                              <PageTitle title="Carrier" />

                              {/* Buttons */}
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "15px",
                                  justifyContent: {
                                    xs: "flex-end",
                                    md: "flex-end",
                                  },
                                  flexWrap: "wrap",
                                  width: { xs: "100%", md: "auto" },
                                }}
                              >
                                <IconButton
                                  onClick={handleRefresh}
                                  className="all_button_clr"
                                  sx={{
                                    fontSize: "14px",
                                    borderRadius: "5px",
                                    color: "#fff",
                                    backgroundColor: "#f5751d!important",
                                    px: 2,
                                    height: "35px",
                                    "&:hover": {
                                      backgroundColor: "#0a140e",
                                    },
                                  }}
                                >
                                  Carrier Reload
                                  <CachedIcon sx={{ ml: 1 }} fontSize="small" />
                                </IconButton>

                                <IconButton
                                  className="all_button_clr"
                                  onClick={handleOpen}
                                  sx={{
                                    fontSize: "14px",
                                    borderRadius: "5px",
                                    color: "#fff",
                                    backgroundColor: "#0a140e",
                                    px: 2,
                                    height: "35px",
                                    "&:hover": {
                                      backgroundColor: "#1b3027",
                                    },
                                  }}
                                >
                                  Add
                                  <AddOutlinedIcon
                                    sx={{ ml: 1 }}
                                    fontSize="small"
                                  />
                                </IconButton>
                              </Box>
                            </Box>

                            {/*  */}

                            <Dialog
                              className="custom_dailog_box_user"
                              open={open}
                              sx={{ textAlign: "center" }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  paddingTop: "10px",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography
                                  className="modal_heading"
                                  sx={{
                                    color: "#133325",
                                    fontWeight: "600",
                                    width: "500px",
                                  }}
                                >
                                  Add Carrier
                                </Typography>
                                <IconButton
                                  className="close_icon"
                                  onClick={handleClose}
                                  sx={{ float: "inline-end" }}
                                >
                                  <Close />
                                </IconButton>
                              </Box>
                              <DialogContent>
                                <form>
                                  <form
                                    style={{
                                      textAlign: "center",
                                      textAlign: "center",
                                      // height: "348px",
                                      height: "auto",
                                      // verflow: "auto",
                                      paddingTop: "10px",
                                      padding: "5px",
                                    }}
                                  >
                                    <Grid container spacing={1}>
                                      <Grid item xs={12}>
                                        <TextField
                                          style={{
                                            width: "100%",
                                            margin: " 5px 0 5px 0",
                                          }}
                                          type="text"
                                          label="Name"
                                          variant="outlined"
                                          padding={"0px 0 !important"}
                                          name="carrierName"
                                          value={name}
                                          onChange={(e) =>
                                            setName(e.target.value)
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12}>
                                        <FormControl
                                          fullWidth
                                          style={{ width: "100%" }}
                                        >
                                          <InputLabel id="demo-simple-select-label">
                                            Reg Type
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Reg Type"
                                            helperText="Select the language."
                                            style={{ textAlign: "left" }}
                                            value={regType}
                                            onChange={(e) => {
                                              setRegType(e.target.value);
                                            }}
                                          >
                                            <MenuItem value={"Register"}>
                                              Register
                                            </MenuItem>
                                            <MenuItem value={"No Register"}>
                                              No Register
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                      <Grid item xs={12}>
                                        {regType === "Register" ? (
                                          <>
                                            <TextField
                                              style={{
                                                width: "100%",
                                                margin: " 5px 0 5px 0",
                                              }}
                                              type="text"
                                              label="Username"
                                              variant="outlined"
                                              padding={"0px 0 !important"}
                                              name="username"
                                              value={username}
                                              onChange={(e) =>
                                                setUsername(e.target.value)
                                              }
                                            />
                                            <br />

                                            <TextField
                                              style={{
                                                width: "100%",
                                                margin: " 5px 0 5px 0",
                                              }}
                                              type={
                                                showPassword
                                                  ? "text"
                                                  : "password"
                                              }
                                              label="Password"
                                              variant="outlined"
                                              name="password"
                                              value={password}
                                              onChange={(e) => {
                                                setPassword(e.target.value);
                                              }}
                                              InputProps={{
                                                startAdornment: (
                                                  <InputAdornment
                                                    position="start"
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={
                                                      handlePasswordVisibility
                                                    }
                                                  >
                                                    {showPassword ? (
                                                      <VisibilityIcon />
                                                    ) : (
                                                      <VisibilityOffIcon />
                                                    )}
                                                  </InputAdornment>
                                                ),
                                              }}
                                            />
                                            <br />
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                      </Grid>
                                      <Grid item xs={12}>
                                        <FormControl
                                          fullWidth
                                          style={{ width: "100%" }}
                                        >
                                          <InputLabel id="demo-simple-select-label">
                                            Type
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Type"
                                            helperText="Select the language."
                                            style={{ textAlign: "left" }}
                                            value={type}
                                            onChange={(e) => {
                                              setType(e.target.value);
                                            }}
                                          >
                                            <MenuItem value={"Outbound"}>
                                              Outbound
                                            </MenuItem>
                                            <MenuItem value={"Inbound"}>
                                              Inbound
                                            </MenuItem>
                                            <MenuItem value={"Both"}>
                                              Both
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                      <Grid item xs={12}>
                                        <TextField
                                          style={{
                                            width: "100%",
                                          }}
                                          type="text"
                                          label="SIP Server"
                                          variant="outlined"
                                          padding={"0px 0 !important"}
                                          name="carrierIP"
                                          value={ipAddress}
                                          onChange={(e) =>
                                            setIpAddress(e.target.value)
                                          }
                                        />
                                        <InputLabel
                                          style={{
                                            textAlign: "left",
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Tooltip
                                            style={{ color: "#fff" }}
                                            title="Example: sip.telcolinellc.com:5080"
                                            classes={{
                                              tooltip: classes.tooltip,
                                            }}
                                          >
                                            <InfoIcon
                                              style={{
                                                fontSize: "18px",
                                                color: "#0a140e",
                                              }}
                                            />
                                            &nbsp;
                                          </Tooltip>
                                        </InputLabel>
                                      </Grid>
                                      <Grid item xs={12}>
                                        <TextField
                                          style={{
                                            width: "100%",
                                          }}
                                          type="text"
                                          label="Toll Free Priority"
                                          variant="outlined"
                                          padding={"0px 0 !important"}
                                          name="tollFreePriority"
                                          value={tollFreePriority}
                                          onChange={(e) =>
                                            setTollFreePriority(e.target.value)
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12}>
                                        <TextField
                                          style={{
                                            width: "100%",
                                          }}
                                          type="text"
                                          label="Local Priority"
                                          variant="outlined"
                                          padding={"0px 0 !important"}
                                          name="localPriority"
                                          value={localPriority}
                                          onChange={(e) =>
                                            setLocalPriority(e.target.value)
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12}>
                                        <FormControl
                                          fullWidth
                                          style={{ width: "100%" }}
                                        >
                                          <InputLabel id="demo-simple-select-label">
                                            Status
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Status"
                                            helperText="Select the language."
                                            style={{ textAlign: "left" }}
                                            value={status}
                                            onChange={(e) => {
                                              setStatus(e.target.value);
                                            }}
                                          >
                                            <MenuItem value={"t"}>
                                              Active
                                            </MenuItem>
                                            <MenuItem value={"f"}>
                                              Deactive
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                    </Grid>
                                  </form>
                                </form>
                              </DialogContent>
                              <DialogActions
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  paddingBottom: "20px",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  className="all_cancel_btn"
                                  color="primary"
                                  sx={{
                                    fontSize: "16px !impotant",
                                    background:
                                      "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                    marginTop: "0px",
                                    padding: "10px 20px !important",
                                    textTransform: "capitalize !important",
                                  }}
                                  onClick={handleClose}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="contained"
                                  className="all_button_clr"
                                  color="primary"
                                  sx={{
                                    fontSize: "16px !impotant",
                                    background: "#092b5f",
                                    marginTop: "0px",
                                    padding: "10px 20px !important",
                                    textTransform: "capitalize !important",
                                  }}
                                  onClick={handleSubmit}
                                >
                                  save
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </div>

                          {/* edit-modal */}
                          <Dialog
                            className="custom_dailog_box_user"
                            open={openModal}
                            // onClose={handleCloseModal}
                            sx={{ textAlign: "center" }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                paddingTop: "10px",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography
                                className="modal_heading"
                                sx={{
                                  color: "#133325",
                                  fontWeight: "600",
                                  width: "500px",
                                }}
                              >
                                Edit Carrier
                              </Typography>
                              <IconButton
                                className="close_icon"
                                onClick={handleCloseModal}
                                sx={{ float: "inline-end" }}
                              >
                                <Close />
                              </IconButton>
                            </Box>
                            <DialogContent>
                              <Box
                                component="form"
                                sx={{
                                  width: "100%",
                                  p: 2,
                                }}
                              >
                                <Grid container spacing={1}>
                                  {/* Name */}
                                  <Grid item xs={12}>
                                    <TextField
                                      fullWidth
                                      label="Name"
                                      value={name}
                                      disabled
                                    />
                                  </Grid>

                                  {/* Reg Type */}
                                  <Grid item xs={12}>
                                    <FormControl fullWidth>
                                      <InputLabel>Reg Type</InputLabel>
                                      <Select
                                        value={regType}
                                        label="Reg Type"
                                        onChange={(e) =>
                                          setRegType(e.target.value)
                                        }
                                        style={{ textAlign: "left" }}
                                      >
                                        <MenuItem value="Register">
                                          Register
                                        </MenuItem>
                                        <MenuItem value="No Register">
                                          No Register
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  {/* Type */}
                                  <Grid item xs={12}>
                                    <FormControl fullWidth>
                                      <InputLabel>Type</InputLabel>
                                      <Select
                                        value={type}
                                        label="Type"
                                        onChange={(e) =>
                                          setType(e.target.value)
                                        }
                                        style={{ textAlign: "left" }}
                                      >
                                        <MenuItem value="Outbound">
                                          Outbound
                                        </MenuItem>
                                        <MenuItem value="Inbound">
                                          Inbound
                                        </MenuItem>
                                        <MenuItem value="Both">Both</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>

                                  {/* Conditional Fields */}
                                  {regType === "Register" && (
                                    <>
                                      <Grid item xs={12}>
                                        <TextField
                                          fullWidth
                                          label="Username"
                                          value={username}
                                          onChange={(e) =>
                                            setUsername(e.target.value)
                                          }
                                        />
                                      </Grid>

                                      <Grid item xs={12}>
                                        <TextField
                                          fullWidth
                                          type={
                                            showPassword ? "text" : "password"
                                          }
                                          label="Password"
                                          value={password}
                                          onChange={(e) =>
                                            setPassword(e.target.value)
                                          }
                                          InputProps={{
                                            endAdornment: (
                                              <InputAdornment
                                                position="end"
                                                sx={{ cursor: "pointer" }}
                                                onClick={
                                                  handlePasswordVisibility
                                                }
                                              >
                                                {showPassword ? (
                                                  <VisibilityIcon />
                                                ) : (
                                                  <VisibilityOffIcon />
                                                )}
                                              </InputAdornment>
                                            ),
                                          }}
                                        />
                                      </Grid>
                                    </>
                                  )}

                                  {/* SIP Server */}
                                  <Grid item xs={12}>
                                    <TextField
                                      fullWidth
                                      label="SIP Server"
                                      value={ipAddress}
                                      onChange={(e) =>
                                        setIpAddress(e.target.value)
                                      }
                                      helperText="Example: sip.telcolinellc.com:5080"
                                    />
                                  </Grid>

                                  {/* Toll Free Priority */}
                                  <Grid item xs={12} md={6}>
                                    <TextField
                                      fullWidth
                                      label="Toll Free Priority"
                                      value={tollFreePriority}
                                      onChange={(e) =>
                                        setTollFreePriority(e.target.value)
                                      }
                                    />
                                  </Grid>

                                  {/* Local Priority */}
                                  <Grid item xs={12} md={6}>
                                    <TextField
                                      fullWidth
                                      label="Local Priority"
                                      value={localPriority}
                                      onChange={(e) =>
                                        setLocalPriority(e.target.value)
                                      }
                                    />
                                  </Grid>

                                  {/* Status */}
                                  <Grid item xs={12}>
                                    <FormControl fullWidth>
                                      <InputLabel>Status</InputLabel>
                                      <Select
                                        value={status}
                                        label="Status"
                                        onChange={(e) =>
                                          setStatus(e.target.value)
                                        }
                                        style={{ textAlign: "left" }}
                                      >
                                        <MenuItem value="t">Active</MenuItem>
                                        <MenuItem value="f">Deactive</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </Grid>
                              </Box>
                            </DialogContent>
                            <DialogActions
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                paddingBottom: "20px",
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: "16px !impotant",
                                  background:
                                    "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                  marginTop: "0px",
                                  marginLeft: "0px !important",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                }}
                                className="all_button_clr"
                                color="info"
                                onClick={handleCloseModal}
                                autoFocus
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: "16px !impotant",
                                  marginTop: "0px",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                  marginLeft: "0px !important",
                                  marginRight: "0px !important",
                                }}
                                className="all_button_clr"
                                color="error"
                                onClick={handleUpdate}
                              >
                                Update
                              </Button>
                            </DialogActions>
                          </Dialog>
                          {/* end-edit-modal*/}

                          {/* Delete Confirmation Modal Start  */}
                          <Dialog
                            open={alertMessage}
                            onClose={handleAlertClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            sx={{ textAlign: "center" }}
                            //className="bg_imagess"
                          >
                            <DialogTitle
                              id="alert-dialog-title"
                              sx={{ color: "#133325", fontWeight: "600" }}
                            >
                              {"Delete Confirmation"}
                            </DialogTitle>
                            <DialogContent>
                              <DialogContentText
                                id="alert-dialog-description"
                                sx={{ paddingBottom: "0px !important" }}
                              >
                                Are you sure you want to delete {name} ?
                              </DialogContentText>
                            </DialogContent>
                            <DialogActions
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                paddingBottom: "20px",
                              }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: "16px !impotant",
                                  background:
                                    "linear-gradient(180deg, #0E397F 0%, #001E50 100%) !important",
                                  marginTop: "20px",
                                  marginLeft: "0px !important",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                }}
                                className="all_button_clr"
                                color="info"
                                onClick={handleAlertClose}
                                autoFocus
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="contained"
                                sx={{
                                  fontSize: "16px !impotant",
                                  marginTop: "20px",
                                  padding: "10px 20px !important",
                                  textTransform: "capitalize !important",
                                  marginLeft: "0px !important",
                                  marginRight: "0px !important",
                                }}
                                className="all_button_clr"
                                color="error"
                                onClick={handleDelete}
                                startIcon={<DeleteIcon />}
                              >
                                Delete
                              </Button>
                            </DialogActions>
                          </Dialog>
                          {/* Delete Confirmation Modal End  */}
                          <ThemeProvider theme={theme}>
                            <div style={{ height: "100%", width: "100%" }}>
                              <StyledDataGrid
                                rows={rows}
                                columns={columns}
                                density="compact"
                                headerClassName="custom-header"
                                // getRowClassName={(params) =>
                                //   `${params.rowClassName} ${
                                //     isRowBordered(params) ? classes.borderedGreen : classes.borderedRed
                                //   } ${classes.spacedRow}`
                                // }
                                components={{ Toolbar: GridToolbar }}
                                slots={{
                                  toolbar: CustomToolbar,
                                }}
                                autoHeight
                              />
                            </div>
                          </ThemeProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
}

export default AdminCarrier;
